import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { AboutUsBlock1 } from "./AboutUsBlock1";
import { AboutUsBlock2 } from "./AboutUsBlock2";
import { AboutUsBlock3 } from "./AboutUsBlock3";
import { AboutUsBlock4 } from "./AboutUsBlock4";

export const aboutUsBlocks: BlockExportMapping = {
  AboutUsBlock1,
  AboutUsBlock2,
  AboutUsBlock3,
  AboutUsBlock4,
};
